(function() {
  'use strict';

  var ENDPOINT = 'https://scybersecure.com/api/validate-order.php';
  var TIMEOUT_MS = 14000;
  var ORDER_ID_PATTERN = /^\d{3}-\d{7}-\d{7}$/;
  var ERROR_CLASS = 'gs-order-validation-error';

  var ERROR_MESSAGES = {
    not_found: 'We couldn\'t verify this order number. Please double-check your Amazon order history. If you need help, <a href="/pages/contact">contact us</a>.',
    invalid_format: 'Please enter a valid Amazon Order ID (format: 123-1234567-1234567).',
    rate_limited: 'Too many attempts. Please wait a moment and try again.',
    unavailable: 'Verification timed out. Please try again.'
  };

  var greenlit = new WeakSet();

  function findOrderField(form) {
    return form.querySelector('input[data-amazon-mask-applied="true"]')
        || form.querySelector('input[name="text-2"]');
  }

  function isDiscountForm(form) {
    return !!(form && findOrderField(form));
  }

  function showError(form, message) {
    var field = findOrderField(form);
    if (!field) return;
    var existing = form.querySelector('.' + ERROR_CLASS);
    var box = existing || document.createElement('div');
    if (!existing) {
      box.className = ERROR_CLASS;
      box.setAttribute('role', 'alert');
      box.style.cssText = 'color:#c41e3a;font-size:14px;line-height:1.4;margin-top:8px;padding:10px 12px;background:#fdecea;border-left:3px solid #c41e3a;border-radius:3px;';
      var control = field.closest('.globo-form-control') || field.parentElement;
      control.appendChild(box);
    }
    box.innerHTML = message;
    box.style.display = 'block';
    field.setAttribute('aria-invalid', 'true');
    field.style.borderColor = '#c41e3a';
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearError(form) {
    var b = form.querySelector('.' + ERROR_CLASS);
    if (b) b.style.display = 'none';
    var f = findOrderField(form);
    if (f) {
      f.removeAttribute('aria-invalid');
      f.style.borderColor = '';
    }
  }

  // CHANGED: now also swaps the submit button label to "Verifying order..."
  // while a validation call is in flight, then restores the original label.
  // Original behaviour (disable on busy) is unchanged.
  function setBusy(form, busy) {
    var btns = form.querySelectorAll('button[type="submit"], button.wizard__submit, input[type="submit"]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (busy) {
        btn.dataset._gsBusy = '1';
        btn.disabled = true;
        if (btn.tagName === 'INPUT') {
          btn.dataset._gsLabel = btn.value;
          btn.value = 'Verifying order...';
        } else {
          btn.dataset._gsLabel = btn.innerHTML;
          btn.innerHTML = 'Verifying order...';
        }
      } else if (btn.dataset._gsBusy) {
        btn.disabled = false;
        if (typeof btn.dataset._gsLabel !== 'undefined') {
          if (btn.tagName === 'INPUT') {
            btn.value = btn.dataset._gsLabel;
          } else {
            btn.innerHTML = btn.dataset._gsLabel;
          }
          delete btn.dataset._gsLabel;
        }
        delete btn.dataset._gsBusy;
      }
    }
  }

  // CHANGED: fail OPEN on any non-verdict response.
  // A 200 with a JSON verdict is trusted as-is, so a genuine not_found /
  // invalid_format still blocks the submission. But a non-2xx status, a
  // network/CORS failure, an aborted timeout, or an unreadable body all mean
  // the endpoint never returned a verdict, and in that case the customer is
  // allowed through rather than blocked over a server-side problem.
  function callEndpoint(orderId) {
    var ctrl = new AbortController();
    var t = setTimeout(function() { ctrl.abort(); }, TIMEOUT_MS);
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_id: orderId }),
      signal: ctrl.signal,
      mode: 'cors'
    }).then(function(r) {
      clearTimeout(t);
      if (!r.ok) {
        if (window.console) console.log('[order-validation] endpoint HTTP ' + r.status + ', allowing submission (fail-open)');
        return { valid: true, failOpen: true };
      }
      return r.json().catch(function() {
        if (window.console) console.log('[order-validation] endpoint returned an unreadable response, allowing submission (fail-open)');
        return { valid: true, failOpen: true };
      });
    }).catch(function(err) {
      clearTimeout(t);
      if (window.console) console.log('[order-validation] endpoint unreachable, allowing submission (fail-open):', err);
      return { valid: true, failOpen: true };
    });
  }

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !isDiscountForm(form)) return;

    if (greenlit.has(form)) {
      greenlit.delete(form);
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var field = findOrderField(form);
    var orderId = field.value.trim();

    if (!ORDER_ID_PATTERN.test(orderId)) {
      showError(form, ERROR_MESSAGES.invalid_format);
      field.focus();
      return;
    }

    clearError(form);
    setBusy(form, true);

    callEndpoint(orderId).then(function(result) {
      setBusy(form, false);
      if (result.valid) {
        greenlit.add(form);
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } else {
        showError(form, ERROR_MESSAGES[result.reason] || ERROR_MESSAGES.not_found);
        field.focus();
      }
    });
  }, true);

  document.addEventListener('input', function(e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('input[name="text-2"]') || t.matches('input[data-amazon-mask-applied="true"]')) {
      var form = t.closest('form');
      if (form) clearError(form);
    }
  });

  if (window.console) console.log('[order-validation] initialized');
})();